import { Accordion, Drawer, Icon, Icons } from '@silverfort/sf-components';
import { useCallback, useState } from 'react';
import { DEFAULT_FENCING_POLICY } from '../consts';
import { httpPost } from '../../../components/utils';
import { FencingPolicyModel } from '../types/FencingTypes';
import FencingPolicy from './FencingPolicy';
import { formatFencingPolicyForSave } from '../utils/formatters';
import { CreateBulkPolicyProps, handlePolicyCreationResponse, VerificationPopup } from './CreateBulkPolicy';
import { BulkAction, BulkPolicyCreationResponse } from '../types/PrivilegedAccountsTypes';

const BulkFencing = ({ accountGuids, open, onClose, onSave, onError, shouldVerifyAction }: CreateBulkPolicyProps) => {
    const [shouldShowVerificationPopup, setShouldShowVerificationPopup] = useState<boolean>(false);
    const [editedPolicy, setEditedPolicy] = useState<FencingPolicyModel>(DEFAULT_FENCING_POLICY);

    const createBulkFencingPolicy = useCallback(async () => {
        try {
            const createPolicyResponse: BulkPolicyCreationResponse = await httpPost('/fencing/', {
                policy: formatFencingPolicyForSave(editedPolicy),
                userGuids: accountGuids
            });
            handlePolicyCreationResponse(createPolicyResponse, 'Virtual Fencing', accountGuids.length, onError, onSave);
        } catch (error) {
            onError('An error occurred while creating bulk Virtual Fencing policy.');
        }
        setShouldShowVerificationPopup(false);
    }, [editedPolicy, accountGuids]);

    return (
        <>
            {shouldVerifyAction && shouldShowVerificationPopup && (
                <VerificationPopup
                    action={BulkAction.FENCING}
                    accountGuidsCount={accountGuids.length}
                    onApprove={() => {
                        setShouldShowVerificationPopup(false);
                        createBulkFencingPolicy();
                    }}
                    onCancel={() => {
                        setShouldShowVerificationPopup(false);
                        onClose();
                    }}
                />
            )}
            <div>
                <Drawer
                    className="max-w-[720px] w-[720px]"
                    open={open}
                    headerTitle={`Bulk Protection (${accountGuids.length})`}
                    onClose={(e, reason) => reason !== 'backdropClick' && onClose()}
                    onAction={() => {
                        if (shouldVerifyAction) setShouldShowVerificationPopup(true);
                        else createBulkFencingPolicy();
                    }}
                    footerActionTitle="Save"
                    footerCloseTitle="Cancel">
                    <div className="text-13 w-[720px] h-full flex flex-col gap-4">
                        <Accordion
                            sx={{
                                '&:before': {
                                    display: 'none'
                                }
                            }}
                            disableGutters
                            elevation={0}
                            defaultExpanded={true}
                            className="shadow-none border rounded-lg !border-sf-gray-100"
                            summary={
                                <div className="h-[32px] flex items-center pr-2 font-medium">
                                    <span className="pr-4 font-sf-primary">Virtual Fencing Policy</span>
                                </div>
                            }
                            accordionSummaryProps={{
                                expandIcon: <Icon icon={Icons.ChevronDown} />
                            }}
                            accordionDetailsProps={{}}>
                            <FencingPolicy
                                editedPolicy={editedPolicy}
                                account={null}
                                setEditedPolicy={setEditedPolicy}
                                isEditor={true}
                                setOriginalPolicy={(policy) => {}}
                                isActiveOnly={true}
                            />
                        </Accordion>
                    </div>
                </Drawer>
            </div>
        </>
    );
};

export default BulkFencing;
